import React from 'react';
import { sanitizeHtml } from 'utils';
import { resolveRichTextImages } from '../../utils/resolveRichTextImages';
import { useRichTextImageUrls } from '../../hooks/useRichTextImageUrls';

const formatPageNumber = (format, current, total) => {
    switch (format) {
        case 'pageX': return `Page ${current}`;
        case 'xSlashY': return `${current}/${total}`;
        case 'xOnly': return `${current}`;
        case 'pageXofY':
        default: return `Page ${current} of ${total}`;
    }
};

export const PrevHeaderFooterBlock = ({ type, data, pageIndex, totalPages, imageUrls: imageUrlsProp }) => {
    const imageUrls = useRichTextImageUrls(data?.show ? data?.content : null, imageUrlsProp);

    if (!data?.show) return null;

    const properties = data.properties || {};
    const isHeader = type === 'header';

    const borderStyle = properties.showBorder !== false
        ? `${properties.borderWidth ?? 1}px solid ${properties.borderColor || '#475467'}`
        : 'none';

    const style = {
        ...(isHeader ? { borderBottom: borderStyle } : { borderTop: borderStyle }),
        backgroundColor: properties.backgroundColor || 'transparent',
    };

    return (
        <div className="form-preview-hf-block" style={style}>
            {data.content && (
                <div
                    className="form-text-editor-style"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(resolveRichTextImages(data.content, imageUrls)) }}
                />
            )}
            {properties.showPageNumbers && (
                <p
                    className="form-preview-page-number"
                    style={{
                        textAlign: (properties.contentPosition || 'Left').toLowerCase(),
                    }}
                >
                    {formatPageNumber(properties.pageNumberFormat, pageIndex + 1, totalPages)}
                </p>
            )}
        </div>
    );
};
